module.exports = __webpack_public_path__ + "img/1513883640.767bf78a.jpg";